module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-144x144-a36056c341f1739816fc9266926222f7.png";